import { render, staticRenderFns } from "./OnAirCard.vue?vue&type=template&id=238288a2"
import script from "./OnAirCard.vue?vue&type=script&lang=ts"
export * from "./OnAirCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports